import { render, staticRenderFns } from "./ChatUserCard.vue?vue&type=template&id=2924a002&scoped=true"
import script from "./ChatUserCard.vue?vue&type=script&lang=js"
export * from "./ChatUserCard.vue?vue&type=script&lang=js"
import style0 from "./ChatUserCard.vue?vue&type=style&index=0&id=2924a002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924a002",
  null
  
)

export default component.exports